import Preview from '.';
import { RouteType } from '@/lib/route';

const PreviewRoutes: RouteType = {
  path: '/preview/:elearningId/:frameId?',
  component: Preview,
};

export interface PreviewParamType {
  elearningId: string;
  frameId?: string;
}

export default PreviewRoutes;
